import { render, staticRenderFns } from "./TurnOverFragment.vue?vue&type=template&id=4079fd71&scoped=true&"
import script from "./TurnOverFragment.vue?vue&type=script&lang=js&"
export * from "./TurnOverFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4079fd71",
  null
  
)

export default component.exports